import React from 'react'
import truncate from 'lodash/truncate'

import { Heading, Link } from 'core'
import { SUBTYPE_LABELS, webinarLinkTo } from 'event-taxonomy'

import css from '../style.scss'

const truncateOptions = {
  length: 200,
  separator: /,?\s+/
}

const ResultSingle = ({ result }) => (
  <div>
    <div className={css.title}>
      {linkify(result,
        <Heading
          size='h5'
          freight
          underline
          noMargin
          className
        >
          {result.title}
        </Heading>
      )}
      <p className={css.resultType}>{resultType(result)}</p>
    </div>
    <p className={css.excerpt}>
      {excerpt(result.content)}
    </p>
  </div>
)

const excerpt = text => truncate(text, truncateOptions)

const linkify = (result, children) => {
  const path = linkPath(result)
  return path ? <Link to={path} target='_blank'>{children}</Link> : children
}

const linkPath = result => {
  switch (result.target_type) {
    case 'webinar':
      return webinarLinkTo(result)
    case 'session_sale':
      return `/sessions/${result.slug}`
    case 'cms_page':
      return `/${result.slug}`
    case 'post':
      switch (result.subtype) {
        case 'monday_motivator':
          return `/monday-motivator/${result.slug}`
        case 'news':
          return `/news/${result.slug}`
      }
  }
}

const resultType = result => {
  switch (result.target_type) {
    // Search results mix content types, so webinars keep the trailing
    // "Webinar" that tells them apart from a program of the same name.
    case 'webinar': {
      const label = SUBTYPE_LABELS[result.subtype]
      return label ? `${label} Webinar` : undefined
    }
    case 'session_sale':
      return SUBTYPE_LABELS[result.subtype]
    case 'cms_page':
      return 'Page'
    case 'post':
      switch (result.subtype) {
        case 'monday_motivator':
          return 'Monday Motivator'
        case 'news':
          return 'News'
      }
  }
}

ResultSingle.propTypes = {
  result: React.PropTypes.shape({
    target_type: React.PropTypes.string.isRequired,
    target_id: React.PropTypes.number.isRequired,
    subtype: React.PropTypes.string,
    title: React.PropTypes.string.isRequired,
    content: React.PropTypes.string
  })
}

export default ResultSingle
